export enum Durations {
  LONG = 'LONG',
  SHORT = 'SHORT'
}

export enum ServiceType {
  Admin = 'Admin',
  Employee = 'Employee',
  None = 'None'
}

export enum EStatus {
  ACTIVE = 'ACTIVE',
  BEGIN_POST_EXECUTION = 'BEGIN_POST_EXECUTION',
  BEGIN_PRE_EXECUTION = 'BEGIN_PRE_EXECUTION',
  COMPLETE = 'COMPLETE',
  CREATED = 'CREATED',
  DELETED = 'DELETED',
  EXECUTION_STARTED = 'EXECUTION_STARTED',
  EXECUTION_STOPPED = 'EXECUTION_STOPPED',
  POST_EXECUTION_COMPLETE = 'POST_EXECUTION_COMPLETE',
  POST_EXECUTION_FAILED = 'POST_EXECUTION_FAILED',
  PRE_EXECUTION_COMPLETE = 'PRE_EXECUTION_COMPLETE',
  PRE_EXECUTION_FAILED = 'PRE_EXECUTION_FAILED'
}

export type IUserState = {
  userName: string;
  siteIds: number[];
  challengeName?: boolean;
  jwtToken: string;
};

export type ISiteState = {
  siteId: number;
  siteName: string;
};

export type ISite = {
  location_type: string;
  name: string;
  volume: string;
  gross_area?: string;
  net_area?: string;
  area: number;
  floor_to_floor_height?: number;
  floor_to_ceiling_height: number;
  address1?: string;
  address2?: string;
  city: string;
  state: string;
  postal_code: string;
  county: string;
  latitude: string;
  longitude: string;
  climate_zone: string;
  naics_code: string;
  utility: {
    name: string;
    abbr?: string;
    eid?: string;
    utility_id: number;
  },
  is_low_enviroscore: boolean;
  district?: unknown,
  enrollment?: unknown,
  level?: number,
  site_id: number
  is_low_income: boolean;
};

export type IEnrollment = {
  name: string,
  description: string,
  strategy_id: number
};

export type ISession = {
  name?: string,
  start?: string,
  end?: string,
  id: number,
  site_id: number,
  status?: EStatus,
  session_status?: EStatus,
  schedule_id?: number
  session_id?: number
};

export type ISchedule = {
  items: ISession[]
  strategy_id?: number,
  enabled?: boolean,
  site_id?: number,
  exclusions?: number[],
  sessions: ISession[],
  id?: number
};
